import { render } from "./form-password-secure.vue?vue&type=template&id=471c67c4"
import script from "./form-password-secure.js?vue&type=script&lang=js&external"
export * from "./form-password-secure.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__